export const radiansToDegrees = (radians: number) => radians * (180 / Math.PI);
